import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "reducers/store"
import { AUTHENTICATION_CHECK_ERROR } from "reducers/user/actions-types"
import { checkUserToken } from "reducers/user/user-actions"

let timer: NodeJS.Timeout

const useRouteAuth = () => {
  const dispatch = useAppDispatch()

  const {
    authentication: { isAuthenticated, hasError, loading: isAuthLoading }
  } = useAppSelector(({ user }) => user)

  const token = localStorage.getItem("token")
  const emptyOrMissingToken = !token || token?.length === 0
  const authInvalid = emptyOrMissingToken || !isAuthenticated || hasError

  useEffect(() => {
    if (emptyOrMissingToken) {
      dispatch({
        type: AUTHENTICATION_CHECK_ERROR,
        payload: { error: "Authentication Failure" }
      })
    } else if (!!token && !isAuthenticated) {
      if (timer) clearTimeout(timer)
      timer = setTimeout(async () => {
        await dispatch(checkUserToken())
      }, 1000)
    }
  }, [token, isAuthenticated, dispatch])

  return {
    isAuthValid: !authInvalid,
    isAuthLoading
  }
}

export default useRouteAuth
